import { DrawingId } from 'src/config/drawings';

interface TopicShared {
  id: string;
  title: string;
  yaw: number;
  pitch: number;
  parent: DrawingId;
}

interface TopicMarkdown extends TopicShared {
  type: 'markdown';
  markdown: string;
}

interface TopicScene extends TopicShared {
  type: 'scene';
  drawingId: DrawingId;
}

export type Topic = TopicMarkdown | TopicScene;

export const topics: Topic[] = [
  /**
   * Parent: Brug, onderwijskundig leiderschap
   */
  {
    id: '3d5da158-0bd3-416e-8082-21095928fe22',
    type: 'scene',
    title: 'Naar kraancabine: thematisch onderwijs',
    drawingId: 'kraancabine',
    pitch: 8.027236445234095,
    yaw: -25.416825732624886,
    parent: 'brug',
  },
  {
    id: '39f690b4-0cd4-4af6-b951-49d4c5e95ff4',
    type: 'scene',
    title: 'Naar machinekamer: professionele basis',
    drawingId: 'machinekamer',
    pitch: -30.49456161989297,
    yaw: -53.68607982667944,
    parent: 'brug',
  },
  {
    id: 'f866e661-08bc-476a-82c2-989647ce4db4',
    type: 'markdown',
    title: 'Transformatieve school',
    markdown: './transformatieve-school.md',
    pitch: -11.373097980461967,
    yaw: 58.9152424410928,
    parent: 'brug',
  },
  {
    id: 'a445c0fc-399d-4138-92a3-399090ccd582',
    type: 'markdown',
    title: 'Kernteam',
    markdown: './kernteam.md',
    pitch: -13.134098831715397,
    yaw: 13.689624943857062,
    parent: 'brug',
  },
  {
    id: 'e2fed031-0560-445b-bf66-ab90d57ed6a5',
    type: 'markdown',
    title: 'Autonomie binnen professionele ruimte',
    markdown: './autonomie-binnen-professionele-ruimte.md',
    pitch: -2.763862267823388,
    yaw: 79.4729364309378,
    parent: 'brug',
  },
  {
    id: 'a1ec5f6f-90f4-47a4-9687-2f35ee6bfeac',
    type: 'markdown',
    title: 'Professionalisering',
    markdown: './professionalisering.md',
    pitch: 2.522810570699485,
    yaw: 30.501151262040107,
    parent: 'brug',
  },

  /**
   * Parent: Kraancabine, thematisch onderwijs
   */
  {
    id: 'fd1dbe59-d1e4-4c56-a9dd-152c96246865',
    type: 'markdown',
    title: 'Thema\'s',
    markdown: './themas.md',
    pitch: -1.422664093412942,
    yaw: 0,
    parent: 'kraancabine',
  },
  {
    id: '172ad081-cef3-456d-aa05-150978e18859',
    type: 'markdown',
    title: 'Leren in praktijk',
    markdown: './leren-in-praktijk.md',
    pitch: -25.403720311781814,
    yaw: 41.50129716182592,
    parent: 'kraancabine',
  },
  {
    id: '65dbbd72-2514-4592-96d9-ba68db285b1d',
    type: 'markdown',
    title: 'Persoonlijke ontwikkeling student',
    markdown: './persoonlijke-ontwikkeling-student.md',
    pitch: -16.503841631713982,
    yaw: -31.738025496437817,
    parent: 'kraancabine',
  },
  {
    id: 'a40c63b6-b391-4ece-98cb-caf115493bf9',
    type: 'markdown',
    title: 'Examinering',
    markdown: './examinering.md',
    pitch: -29.258819280729448,
    yaw: -44.71590763938306,
    parent: 'kraancabine',
  },
  {
    id: '63098b37-cbcf-4894-b48b-2e2627aeeb1d',
    type: 'markdown',
    title: 'Internationalisering',
    markdown: './internationalisering.md',
    pitch: 8.998413039347568,
    yaw: -68.28124205593441,
    parent: 'kraancabine',
  },
  {
    id: '0ced23a4-6ab9-4d5f-bebd-8ac07fb08f44',
    type: 'scene',
    title: 'Naar brug: onderwijskundig leiderschap',
    drawingId: 'brug',
    pitch: 10.944863163704197,
    yaw: 48.94254923527938,
    parent: 'kraancabine',
  },

  /**
   * Parent: Machinekamer, professionele basis
   */
  {
    id: '3e2ee214-a179-45e6-a716-e4bc6ab432ef',
    type: 'scene',
    title: 'Naar brug: onderwijskundig leiderschap',
    drawingId: 'brug',
    pitch: 10.944863163704197,
    yaw: 48.94254923527938,
    parent: 'machinekamer',
  },
  {
    id: 'be0f9f2b-e03a-4674-bf99-fc9072e9a5c3',
    type: 'markdown',
    title: 'Loopbaanpunt',
    markdown: './loopbaanpunt.md',
    pitch: -13.750331146773059,
    yaw: 71.8900042348049,
    parent: 'machinekamer',
  },
  {
    id: '1eb489a4-796e-4aa7-9cfd-8d42957dab75',
    type: 'markdown',
    title: 'Leerkracht',
    markdown: './leerkracht.md',
    pitch: -7.372642896168893,
    yaw: 5.659767321410095,
    parent: 'machinekamer',
  },
  {
    id: 'e5eaa4a6-4c94-43c1-ae88-77db05659a00',
    type: 'markdown',
    title: 'Klas als werkplaats',
    markdown: './klas-als-werkplaats.md',
    pitch: -4.038810695318288,
    yaw: -10.381515480161612,
    parent: 'machinekamer',
  },
  {
    id: 'b750024e-c929-4c45-ae0c-6045356078b4',
    type: 'markdown',
    title: 'Cyclisch werken',
    markdown: './cyclisch-werken.md',
    pitch: 1.0530714891602344,
    yaw: -37.220273720832104,
    parent: 'machinekamer',
  },
  {
    id: '085cea1e-916e-459a-8409-b7a308d4d0bf',
    type: 'markdown',
    title: 'Progressiegericht werken',
    markdown: './progressie-gericht-werken.md',
    pitch: -7.521033113932059,
    yaw: -65.6490958274295,
    parent: 'machinekamer',
  },

  /**
   * Parent: Lounge, ontmoeting en verbinding
   */
  {
    id: '9a034a77-7406-43eb-aae8-d7129efe2f2b',
    type: 'markdown',
    title: 'Aandacht voor leefwereld',
    markdown: './aandacht-voor-leefwereld-student.md',
    pitch: -5.74063238235191,
    yaw: -36.56268579269798,
    parent: 'lounge',
  },
  {
    id: 'b1f6f09c-d207-48d4-a316-73cdf59a134a',
    type: 'markdown',
    title: 'Veilige en gezonde school',
    markdown: './veilige-en-gezonde-school.md',
    pitch: -7.141886366403416,
    yaw: -7.896674394297168,
    parent: 'lounge',
  },
  {
    id: '64871640-0041-4aec-8b65-7d0911f07e9c',
    type: 'markdown',
    title: 'Huisvesting',
    markdown: './huisvesting.md',
    pitch: 2.359871944449483,
    yaw: 18.525757774217514,
    parent: 'lounge',
  },
  {
    id: 'b8663881-3fcf-4b61-bce1-1f89bc2c2322',
    type: 'markdown',
    title: 'Diversiteit en Inclusie',
    markdown: './diversiteit-en-inclusie.md',
    pitch: 0.8490725861013748,
    yaw: 33.81997089126986,
    parent: 'lounge',
  },
  {
    id: '8a3bdf40-bb96-4d1f-b902-7212facee000',
    type: 'markdown',
    title: 'Altijd open',
    markdown: './altijd-open.md',
    pitch: 1.3533486981126583,
    yaw: 87.71075460345996,
    parent: 'lounge',
  },

  /**
   * Parent: Ingang, iedereen is welkom!
   */
  {
    id: 'c107106a-a804-4a60-a840-110dfc5fc97f',
    type: 'markdown',
    title: 'Reguliere & specifieke doelgroepen',
    markdown: './reguliere-specifieke-doelgroepen.md',
    pitch: 0.34700972718608314,
    yaw: -12.403166702236566,
    parent: 'ingang',
  },
  {
    id: '51b364b4-eab5-415e-8872-dcf54b7b5b56',
    type: 'markdown',
    title: 'Beroepsopleidingen',
    markdown: './beroepsopleidingen.md',
    pitch: -2.980402312632334,
    yaw: 2.8717777146637578,
    parent: 'ingang',
  },
  {
    id: '0fae4d37-533c-4893-93a4-18e7399fb006',
    type: 'markdown',
    title: 'Intake, plaatsing en binding',
    markdown: './intake-plaatsing-en-binding.md',
    pitch: -2.289055013192611,
    yaw: 16.493670402374494,
    parent: 'ingang',
  },

  /**
   * Parent: Uitkijk, Positonering naar buiten
   */
  {
    id: '3450595b-c78c-40d3-b260-98c78297d06c',
    type: 'markdown',
    title: 'Startacademie',
    markdown: './startacademie.md',
    pitch: -9.422995095065016,
    yaw: -16.87996624738351,
    parent: 'de-uitkijk',
  },
  {
    id: '1b530bff-cb01-4a13-b8ff-aab6a7235093',
    type: 'markdown',
    title: 'Duurzame samenwerkingen',
    markdown: './duurzame-samenwerkingen.md',
    pitch: 2.301602322486387,
    yaw: 5.500684641316113,
    parent: 'de-uitkijk',
  },
  {
    id: '66b9c32c-44f0-4732-a00c-22cec671cdd1',
    type: 'markdown',
    title: 'Succesvolle doorstroom',
    markdown: './succesvolle-doorstroom.md',
    pitch: 13.162667578409266,
    yaw: 30.389053264021737,
    parent: 'de-uitkijk',
  },

  /**
   * Parent: Boeg, onze missie!
   */
  {
    id: '5488da4f-063d-4550-b819-f8989806d76f',
    type: 'markdown',
    title: 'Ik ontwikkel mijn leven lang!',
    markdown: './ik-ontwikkel-mijn-leven-lang-.md',
    pitch: 0,
    yaw: 0,
    parent: 'boeg',
  },
  {
    id: 'ccd69740-2250-4224-99e9-9c8bd544eaea',
    type: 'markdown',
    title: 'Ik weet wat ik wil!',
    markdown: './ik-weet-wat-ik-wil.md',
    pitch: -10.027469962731912,
    yaw: 28.51794165966977,
    parent: 'boeg',
  },
  {
    id: '8302d93a-52dc-4391-b2de-5eb225d547b3',
    type: 'markdown',
    title: 'Ik geloof dat ik het kan!',
    markdown: './ik-geloof-dat-ik-het-kan.md',
    pitch: -10.713900291664384,
    yaw: -24.881658687070175,
    parent: 'boeg',
  },
];
